import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table, TableCell, TableRow, TableBody, Tooltip } from "@mui/material";
import TextEllipsis from "../../../../../text/TextEllipsis";

const RowMin = ({ f, t, size }) => {
  return (
    <div className="flex gap-1 items-center justify-between">
      <TextEllipsis className="text-xs max-w-100px">
        {f.isLevel
          ? `${f?.levelName || f.levelId}`
          : `Working towards `}
      </TextEllipsis>
      <div className="flex gap-1 items-center justify-between">
        <Tooltip title={f.definition} arrow>
          <span
            className="rounded-full cursor-pointer hover-outline-muted"
            style={{
              width: size,
              height: size,
              backgroundColor: f.completedPrimaryColor,
            }}
          />
        </Tooltip>
        <FontAwesomeIcon
          icon="arrow-right"
          className="text-muted-foreground opacity-50"
        />
        <Tooltip title={f.definition} arrow>
          <div
            className="rounded-full cursor-pointer hover-outline-muted"
            style={{
              width: size,
              height: size,
              backgroundColor: t.completedPrimaryColor,
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
};

const ElementsFromTo = ({
  id,
  from,
  to,
}) => {
  const size = 16;
  return (
    <Table className="mb-4">
      <TableBody>
        {from
          .filter(
            (f) => f.definition
          )
          .map((f, i) => {
            const t = to[i];
            return (
              <TableRow key={`log-${id}-${f.level}-gs-${f.id}`}>
                <TableCell>
                    <RowMin
                      f={f}
                      t={t}
                      size={size}
                    />
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

export default ElementsFromTo;
